export default "__VITE_ASSET__734d3071__"